<template>
  <v-app>
    <v-content>
      <drawer></drawer>
      <toolbar></toolbar>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Drawer from './components/Drawer'
  import Toolbar from './components/Toolbar'

  export default {
    name: 'App',
    components: {
      Drawer,
      Toolbar
    },
    data: () => ({
      //
    }),
    computed: {
      ...mapGetters(['theme']),
      viewport() {
        return this.$vuetify.breakpoint.mdAndDown
      }
    },
    watch: {
      viewport(val) {
        this.$store.dispatch('setIsDesktop', !val)
      }
    },
    created() {
      document.title = 'Bytewood | Admin Panel'

      this.$vuetify.theme.themes.dark.primary = '#009688'
      this.$vuetify.theme.themes.dark.accent = '#00BFA5'
      this.$vuetify.theme.themes.light.primary = '#1876D2'

      this.$store.dispatch('setIsDesktop', !this.$vuetify.breakpoint.mdAndDown)
    }
  };
</script>

<style>
  * {
    font-weight: bold !important;
  }
  .theme--dark.v-tabs-items {
    background-color: #303030 !important;
  }

  .theme--light.v-tabs-items {
    background-color: #fafafa !important;
  }
</style>
